import React, { FC } from 'react';

import { generatePath, Navigate, useLocation } from 'react-router-dom';

import { ChatByIdPath } from '~/modules/chat/constants';

/** Root `/` → `/chat/index` while preserving deep-link query params (e.g. `?model=claude`). */
const ChatRootRedirect: FC = () => {
  const { search } = useLocation();

  return (
    <Navigate
      to={{
        pathname: generatePath(ChatByIdPath, { chatId: 'index' }),
        search,
      }}
      replace
    />
  );
};

export default ChatRootRedirect;
